export default __webpack_public_path__ + "static/media/15.93263e91.jpg";